(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oakline-personalisation"] && !Shopify.designMode) return;
  try {
    (() => {
    const maxBytes = 10 * 1024 * 1024;
    const types = ['image/jpeg', 'image/png', 'image/webp'];
    const positions = { Centre: 'center', Top: 'center top', Bottom: 'center bottom', Left: 'left center', Right: 'right center' };
    function bind(root = document) {
      root.querySelectorAll('[data-oakline-personalisation]:not([data-bound])').forEach(panel => {
        panel.dataset.bound = 'true';
        const mode = panel.querySelector('[data-design-type]');
        const text = panel.querySelector('[data-engraving-text]');
        const font = panel.querySelector('[data-font-style]');
        const file = panel.querySelector('[data-artwork]');
        const fit = panel.querySelector('[data-fit]');
        const position = panel.querySelector('[data-position]');
        const preview = panel.querySelector('[data-preview]');
        const surface = panel.querySelector('[data-surface]');
        const engraving = panel.querySelector('.oakline-personalisation__engraving');
        const previewText = panel.querySelector('[data-preview-text]');
        const previewImage = panel.querySelector('[data-preview-image]');
        let objectUrl;
        function update() {
          const needsText = mode.value.includes('Text');
          const needsPicture = mode.value.includes('picture') || mode.value === 'Picture';
          panel.querySelector('[data-text-fields]').hidden = !needsText;
          panel.querySelector('[data-picture-fields]').hidden = !needsPicture;
          text.disabled = font.disabled = !needsText;
          file.disabled = fit.disabled = position.disabled = !needsPicture;
          text.required = needsText;
          file.required = needsPicture;
          preview.hidden = !mode.value;
          previewText.hidden = !needsText || !text.value.trim();
          previewText.textContent = text.value;
          previewImage.hidden = !needsPicture || !objectUrl;
          engraving.dataset.both = String(needsText && needsPicture);
          engraving.dataset.font = font.value === 'Clean sans' ? 'sans' : font.value === 'Handwritten' ? 'handwritten' : 'serif';
          previewImage.style.objectFit = fit.value === 'Fill area, crop edges' ? 'cover' : 'contain';
          previewImage.style.objectPosition = positions[position.value] || 'center';
          surface.dataset.mode = mode.value;
        }
        file.addEventListener('change', () => {
          const selected = file.files[0];
          file.setCustomValidity('');
          if (selected && !types.includes(selected.type)) file.setCustomValidity(panel.dataset.fileError);
          if (selected && selected.size > maxBytes) file.setCustomValidity(panel.dataset.sizeError);
          if (!file.checkValidity()) { file.reportValidity(); file.value = ''; }
          if (objectUrl) URL.revokeObjectURL(objectUrl);
          objectUrl = file.files[0] ? URL.createObjectURL(file.files[0]) : null;
          if (objectUrl) previewImage.src = objectUrl;
          else previewImage.removeAttribute('src');
          update();
        });
        [mode, text, font, fit, position].forEach(field => field.addEventListener('input', update));
        update();
      });
    }
    bind();
    document.addEventListener('DOMContentLoaded', () => bind());
    document.addEventListener('shopify:section:load', event => bind(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
